import React, { useState, useEffect } from 'react';
import { collection, getDocs, orderBy, query, updateDoc, doc } from 'firebase/firestore';
import { db, auth } from '../../firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import '../styles/AdminDashboard.css';

const AdminDashboard = () => {
  const [pendingAppointments, setPendingAppointments] = useState([]);
  const [doneAppointments, setDoneAppointments] = useState([]);
  const [showPending, setShowPending] = useState(true); // Toggle state
  const navigate = useNavigate();

  useEffect(() => {
    onAuthStateChanged(auth, async (user) => {
      if (user) {
        await displayAppointments();
      } else {
        navigate('/auth');
      }
    });
  }, [navigate]);

  const displayAppointments = async () => {
    try {
      const q = query(collection(db, 'appointments'), orderBy('timestamp', 'desc'));
      const querySnapshot = await getDocs(q);
      const appointmentsData = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));

      const pending = appointmentsData.filter((appointment) => appointment.status !== 'done');
      const done = appointmentsData.filter((appointment) => appointment.status === 'done');

      setPendingAppointments(pending);
      setDoneAppointments(done);
    } catch (error) {
      console.error('Error getting appointments: ', error);
    }
  };

  const markAsDone = async (appointmentId) => {
    try {
      await updateDoc(doc(db, 'appointments', appointmentId), {
        status: 'done',
      });
      await displayAppointments();
    } catch (error) {
      console.error('Error marking appointment as done: ', error);
    }
  };

  const toggleView = () => {
    setShowPending(!showPending); // Toggle the state
  };

  return (
    <div className="admin-dashboard">
      <h1>Admin Dashboard</h1>

      <button onClick={toggleView} className="toggle-button">
        {showPending ? 'Show Done Appointments' : 'Show Pending Appointments'}
      </button>

      <h2>{showPending ? 'Pending Appointments' : 'Done Appointments'}</h2>
      <div className="appointment-list">
        {(showPending ? pendingAppointments : doneAppointments).map((appointment) => (
          <div key={appointment.id} className="appointment-item">
            <p><strong>Name:</strong> {appointment.name}</p>
            <p><strong>Mobile:</strong> {appointment.mobile}</p>
            <p><strong>Message:</strong> {appointment.message}</p>
            <p><strong>Timestamp:</strong> {new Date(appointment.timestamp.seconds * 1000).toLocaleString()}</p>
            {showPending && (
              <button onClick={() => markAsDone(appointment.id)}>Mark as Done</button>
            )}
            <hr />
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminDashboard;